import {findIndex, groupBy} from "lodash";
import {getFiltersListFromFeaturesArray} from "./FeaturesFiltersActions";

/**
 * Toggle Array Value
 * @param {Array} array to toggle
 * @param {value} value
 * @param {number} passedIndex
 * @returns {Array}
 */
export const toggleArrayValue = (array, value, passedIndex) => {
  let index = Number.isInteger(passedIndex) ? passedIndex : array.indexOf(value);
  (index >= 0) ? array.splice(index, 1) : array.push(value);
  return array;
};

/**
 * Toggle Array Value
 * @param {Array} array to toggle
 * @param {object} testObject
 * @param {string|number} property
 * @returns {Array}
 */
export const toggleArrayObject = (array, testObject, property) => {
  let index = array.findIndex(arrayObject => arrayObject[property] === testObject[property]);
  (index >= 0) ? array.splice(index, 1) : array.push(testObject);
  return array;
};

/**
 * Replaces Array Value
 * @param {Array} array to toggle
 * @param {object} testObject
 * @param {string|number} property
 * @returns {Array}
 */
export const replaceArrayObject = (array, testObject, property) => {
  return array.map(object => {
    if (testObject[property] === object[property]) {
      return testObject
    }
    return object
  })
};

export const toggleFilterArrayValue = (array, {filterId, filterGroupId}) => {
  let index = findIndex(array, {filterId});
  if (index >= 0) {
    array.splice(index, 1);
  } else {
    array.push({filterId, filterGroupId});
  }
  return array;
};

export const mergeFilterObjects = (dbFeature, hideMasterProfileFilters) => {
  if (hideMasterProfileFilters) {
    return [
      ...(dbFeature.fabFilterValueIds || []),
    ]
  }
  return [
    ...(dbFeature.filterValueIds || []),
    ...(dbFeature.fabFilterValueIds || []),
    ...(dbFeature.stoneFilterValueIds || [])
  ]
}

export function featureHasSelectedFilters(dbFeature, filters) {
  const featureFilterValueIds = mergeFilterObjects(dbFeature);
  var groupedFilters = groupBy(filters, _ => _.filterGroupId);
  var match = true;
  for(var group in groupedFilters) {
    match = match && groupedFilters[group].some(filterObject => {
      return filterObject.filterId && featureFilterValueIds.includes(filterObject.filterId);
    });
    if(!match) {
      break;
    }
  }
  return match;
}

export function filterFeaturesByValues(features, filters) {
  return features.filter(dbFeature => {
    return featureHasSelectedFilters(dbFeature, filters)
  });
}

/**
 * returns all available filter groups with values for navItems
 * @param features {[featureInterface]}
 * @param allFilterGroups {array}
 * @param subDomain {string}
 * @returns {array}
 */
export const getAvailableFiltersForFeatures = (features, allFilterGroups, subDomain) => {
  const allFeatureGroupFilters = getFiltersListFromFeaturesArray(features, [], subDomain);

  return allFilterGroups.map(filterGroup => {
    return Object.assign({}, filterGroup, {
      values: filterGroup.values.filter(fValue => allFeatureGroupFilters.includes(fValue.id)),
    });
  }).filter(filterGroup => filterGroup.values.length)
}
